import React, { useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import Style from './BlackFridayBanner.styles';
import { Paragraph, Headline, Span, Image } from 'Common';
import { balloonie, mountain, mobile } from 'images/BlackFriday';

export const BlackFridayBanner = () => {
  const history = useHistory();
  const [hasNotification, setHasNotification] = useState(false);

  const BLACK_FRIDAY_COUPON_CODE = 'BW2025';

  const handleClick = () => {
    history.push(`/buy/?coupon=${BLACK_FRIDAY_COUPON_CODE}`);
  };

  useEffect(() => {
    const check = () => {
      const exists = !!document.querySelector('.notification-box');
      setHasNotification(exists);
    };

    check();

    const observer = new MutationObserver(check);
    observer.observe(document.body, {
      childList: true,
      subtree: true
    });

    return () => observer.disconnect();
  }, []);

  return (
    <Style
      className="black-friday-banner"
      onClick={handleClick}
      role="button"
      hasNotification={hasNotification}
      aria-label="Gehe zur Black Week Aktion"
      tabIndex={0}
      onKeyDown={(e) => {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          handleClick();
        }
      }}
    >
      <div className="content-wrapper">
        <div className="wrapper balloonie">
          <Image src={balloonie} className="bf_balloonie" alt="Eine Figur geht einkaufen" />
        </div>

        <div className="text-wrapper">
          <Headline level={2}>Black Week bringt Achtsamkeit</Headline>
          <Paragraph>
            Jetzt <Span className="bold">60% </Span> Black-Week-Rabatt sichern
          </Paragraph>
        </div>

        <div className="wrapper mountain">
          <Image src={mountain} className="bf_mountain" alt="Berge" />
        </div>
      </div>
      <Image src={mobile} className="bf_mobile_images" alt="Eine Figur geht einkaufen" />
    </Style>
  );
};
